module.exports = __webpack_public_path__ + "img/99.96ad17fc.webp";